var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44624 18.1422C2.50691 18.8126 3.05287 19.3002 3.72015 19.3002H14.1945C14.8618 19.3002 15.4078 18.7923 15.4684 18.1422L16.6412 5.79007H1.27344L2.44624 18.1422Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6417 1.93002H11.5259V1.27991C11.5259 0.568849 10.9597 0 10.2519 0H7.6839C6.97617 0 6.40999 0.568849 6.40999 1.27991V1.93002H1.27391C0.566182 1.93002 0 2.49887 0 3.20993C0 3.92099 0.566182 4.48984 1.27391 4.48984H16.6417C17.3494 4.48984 17.9156 3.92099 17.9156 3.20993C17.9156 2.49887 17.3494 1.93002 16.6417 1.93002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.25272c98ad45f45e8e987b88541de637.svg";
export { ForwardRef as ReactComponent };